import { useEffect, useRef } from "react";

const AdBanner = ({
  adClient = "ca-pub-7999925953450607",
  adSlot,
  adFormat = "auto",
  layout = "",
  layoutKey = "",
  style = { display: "block", minWidth: "300px", minHeight: "50px" },
  className = "adsbygoogle",
}) => {
  const adRef = useRef(null);

  useEffect(() => {
    const pushAd = () => {
      if (!adRef.current) return;

      // Check if ad already loaded
      const status = adRef.current.getAttribute("data-adsbygoogle-status");
      if (status === "done") {
        console.log("Ad already loaded, skipping push");
        return;
      }

      // Get container width
      const width =
        adRef.current.offsetWidth ||
        adRef.current.parentElement?.offsetWidth ||
        0;
      console.log("Trying to push ad, container width:", width);

      if (width > 100) {
        try {
          // Push ad request to Adsense
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          console.log("Ad pushed successfully");
        } catch (e) {
          console.error("Adsense error:", e);
        }
      } else {
        console.warn("Ad container width too small, skipping ad push.");
      }
    };

    pushAd();

    // Resize listener to try re-pushing if ad not loaded and container size changes
    const handleResize = () => {
      if (adRef.current?.getAttribute("data-adsbygoogle-status") !== "done") {
        pushAd();
      }
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [adSlot, adFormat, layout, layoutKey]);

  return (
    <ins
      ref={adRef}
      className={className}
      style={style}
      data-ad-client={adClient}
      data-ad-slot={adSlot}
      data-ad-format={adFormat}
      {...(layout ? { "data-ad-layout": layout } : {})}
      {...(layoutKey ? { "data-ad-layout-key": layoutKey } : {})}
      data-full-width-responsive="true"
    />
  );
};

export default AdBanner;
